import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import PlayerStats from "../../../interfaces/PlayerStats.interface"
import { getSeasonBestPlayers } from "../../../services/players.services"
import Content from "../../../components/Content"
import Loader from "../../../components/Loader"


const SeasonPage = () => {
    const [players, setPlayers] = useState<PlayerStats[]>([])
    const [groupA, setGroupA] = useState<PlayerStats[]>([])
    const [groupB, setGroupB] = useState<PlayerStats[]>([])
    const [groupC, setGroupC] = useState<PlayerStats[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        getSeasonBestPlayers()
            .then((res) => setPlayers(res.data.payload.bestPlayers))
            .catch(() => toast.error("Ha ocurrido un error"))
            .finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        setGroupA(players.filter((_, index) => index < 10))
        setGroupB(players.filter((_, index) => index >= 10 && index < 20))
        setGroupC(players.filter((_, index) => index >= 20 && index < 30))
    }, [players])

    return (

        <Content className="flex flex-col gap-5">
            <p className="text-zinc-700 text-xl">Premios</p>
            <div className="flex items-center gap-5">
                <p className="flex items-center gap-5 text-zinc-700"><span className="min-w-2 max-w-2 min-h-2 max-h-2 bg-yellow-400"></span> Oro</p>
                <p className="flex items-center gap-5 text-zinc-700"><span className="min-w-2 max-w-2 min-h-2 max-h-2 bg-gray-400"></span> Plata</p>
                <p className="flex items-center gap-5 text-zinc-700"><span className="min-w-2 max-w-2 min-h-2 max-h-2 bg-amber-700"></span> Bronce</p>
            </div>
            <div className="flex flex-col gap-10 relative overflow-x-auto">
                {!loading ?
                    <>
                        {/* Grupo A */}
                        <div className="flex flex-col gap-5">
                            <p className="text-zinc-700 text-xl font-bold">Grupo A</p>
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr>
                                        <th scope="col" className="w-[50px] p-3">
                                            #
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Jugador
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            País
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Calidad
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupA.map((stats, index) => (
                                        <tr key={stats.player?.id as string} className={`bg-white border-b border-l-4 ${index + 1 > 3 ? "border-l-transparent" : ""} ${index + 1 === 1 ? "border-l-yellow-400" : ""} ${index + 1 === 2 ? "border-l-gray-400" : ""} ${index + 1 === 3 ? "border-l-amber-700" : ""}`}>
                                            <td className="px-6 py-4">
                                                {index + 1}
                                            </td>
                                            <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                <div className="flex items-center justify-center bg-gray-100 w-[40px] h-[40px] rounded-full text-zinc-700 font-bold">{stats?.player?.name?.at(0)?.toLocaleUpperCase()}</div>
                                                <Link to={`/p/${stats?.player?.name}`}>{stats.player?.name}</Link>
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.player?.country ?
                                                    <div className="flex items-center gap-2">
                                                        <img className="bg-white" src={`https://flagsapi.com/${stats?.player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>
                                                        <p className="text-zinc-700">{stats?.player?.country?.split(",")[1]}</p>
                                                    </div>
                                                    : '-'}
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.base_stats?.quality?.toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Grupo B*/}
                        <div className="flex flex-col gap-5">
                            <p className="text-zinc-700 text-xl font-bold">Grupo B</p>
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr>
                                        <th scope="col" className="w-[50px] p-3">
                                            #
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Jugador
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            País
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Calidad
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupB.map((stats, index) => (
                                        <tr key={stats.player?.id as string} className={`bg-white border-b`}>
                                            <td className="px-6 py-4">
                                                {index + 1}
                                            </td>
                                            <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                <div className="flex items-center justify-center bg-gray-100 w-[40px] h-[40px] rounded-full text-zinc-700 font-bold">{stats?.player?.name?.at(0)?.toLocaleUpperCase()}</div>
                                                <Link to={`/p/${stats?.player?.name}`}>{stats.player?.name}</Link>
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.player?.country ?
                                                    <div className="flex items-center gap-2">
                                                        <img className="bg-white" src={`https://flagsapi.com/${stats?.player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>
                                                        <p className="text-zinc-700">{stats?.player?.country?.split(",")[1]}</p>
                                                    </div>
                                                    : '-'}
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.base_stats?.quality?.toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Grupo C */}
                        <div className="flex flex-col gap-5">
                            <p className="text-zinc-700 text-xl font-bold">Grupo C</p>
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr>
                                        <th scope="col" className="w-[50px] p-3">
                                            #
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Jugador
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            País
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Calidad
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupC.map((stats, index) => (
                                        <tr key={stats.player?.id as string} className={`bg-white border-b`}>
                                            <td className="px-6 py-4">
                                                {index + 1}
                                            </td>
                                            <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                <div className="flex items-center justify-center bg-gray-100 w-[40px] h-[40px] rounded-full text-zinc-700 font-bold">{stats?.player?.name?.at(0)?.toLocaleUpperCase()}</div>
                                                <Link to={`/p/${stats?.player?.name}`}>{stats.player?.name}</Link>
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.player?.country ?
                                                    <div className="flex items-center gap-2">
                                                        <img className="bg-white" src={`https://flagsapi.com/${stats?.player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>
                                                        <p className="text-zinc-700">{stats?.player?.country?.split(",")[1]}</p>
                                                    </div>
                                                    : '-'}
                                            </td>
                                            <td className="px-6 py-4">
                                                {stats?.base_stats?.quality?.toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                    :
                    <Loader />
                }
            </div>
        </Content>
    )
}

export default SeasonPage